import { InputError } from '@campaign-portal/components-library';

export function createMaxLengthInputError(length: unknown): InputError {
	return {
		key: 'maxlength',
		value: 'errors.maxLength',
		params: { amount: String(length) },
	};
}
